import PageManager from "components/PageManager/PageManager";
import { Column, Row, TitleSection } from "components/styles";
import { RECORDS_BY_PAGE } from "../utils/constants"
import FilterButtons from "./FilterButtons/FilterButtons";
import FilterFields from "./FilterFields/FilterFields";

const Header = ({
    searchedFilters,
    studentPenaltyList,
    paginator, filters
}) => {
    const getCaption = () => {
        const { totalRecords } = paginator.data;
        if (totalRecords <= RECORDS_BY_PAGE) 
            return "";
        const { page } = searchedFilters;
        const startRecords = ((page - 1) * RECORDS_BY_PAGE) + 1,
            endRecords = page * RECORDS_BY_PAGE;
        return `Alumnos sancionados ${startRecords} - ${endRecords > totalRecords ? totalRecords : endRecords} de ${totalRecords}`;
    }
    const noRecords = studentPenaltyList.value?.length === 0;
    return (
        <Column>
            <Row width="100%">
                <TitleSection>Sanciones</TitleSection>
                <PageManager 
                    caption={getCaption()}
                    isFreeCaption
                    noPages={noRecords}
                    dataPaginator={{
                        ...paginator.data,
                        setCurrentPage: page => {
                            paginator.movePage(page);
                            studentPenaltyList.setTriggerRequest(true);
                        }
                    }}/>
            </Row>
            <Row width="100%">
                <FilterFields filters={filters}/>
                <FilterButtons 
                    filters={filters}
                    applyFilters={() => studentPenaltyList.setTriggerRequest(true)}/>
            </Row>
        </Column>
    );
}

export default Header;